<template>
  <header class="header">
    <!-- Navigation -->
    <nav class="header__navigation">
      <!-- Home -->
      <router-link
        :to="{ name: 'home' }"
        exact
        active-class="header__menu--active"
        class="header__menu"
      >
        <span>{{ $t('header_1') }}</span>
      </router-link>

      <!-- About -->
      <router-link
        :to="{ name: 'about' }"
        active-class="header__menu--active"
        class="header__menu"
      >
        <span>{{ $t('header_2') }}</span>
      </router-link>

      <!-- Work -->
      <router-link
        :to="{ name: 'work_index' }"
        active-class="header__menu--active"
        class="header__menu"
      >
        <span>{{ $t('header_6') }}</span>
      </router-link>

      <!-- Careers -->
      <router-link
        :to="{ name: 'careers_index' }"
        active-class="header__menu--active"
        class="header__menu"
      >
        <span>{{ $t('header_9') }}</span>
      </router-link>

      <!-- Blog -->
      <router-link
        :to="{ name: 'blog_index' }"
        active-class="header__menu--active"
        class="header__menu"
      >
        <span>{{ $t('header_7') }}</span>
      </router-link>

      <!-- Contact -->
      <router-link
        :to="{ name: 'contact' }"
        active-class="header__menu--active"
        class="header__menu"
      >
        <span>{{ $t('header_3') }}</span>
      </router-link>
    </nav>

    <!-- Hamburger -->
    <div class="header__hamburger">
      <icon-hamburger-view
        :expand="expand"
        @click.native="clickExpand"
      />
    </div>

    <!-- Bliss -->
    <router-link
      :to="{ name: 'home' }"
      active-class=""
      class="header__bliss"
    >
      <i class="icon-bliss" />
    </router-link>

    <!-- Ripple -->
    <div class="header__ripple">
      <ripple-view
        :expand="expand"
        class="ripple--is-black"
      />
    </div>

    <!-- Sidebar -->
    <sidebar-view
      :expand="expand"
      @click-item="clickExpand"
    />
  </header>
</template>

<script>
export default {
  name: 'HeaderView',

  components: {
    IconHamburgerView: () => import('@/icons/icon-hamburger-view'),
    RippleView: () => import('@/components/ripple/ripple-view'),
    SidebarView: () => import('@/components/sidebar/sidebar-view')
  },

  data() {
    return {
      expand: false
    };
  },

  methods: {
    clickExpand() {
      this.expand = !this.expand;

      const body = document.getElementsByTagName('html')[0];
      if (this.expand) {
        window.scrollTo(0, 0);

        body.style.overflow = 'hidden';
      } else {
        body.style.overflow = 'auto';
      }
    }
  }
};
</script>

<style lang="scss" src="../../assets/components/header/header-view.scss"></style>



// WEBPACK FOOTER //
// header-view.vue